/**
 * Art Department i18n labels — same pattern as backend `utils/export_i18n.py`.
 * Kept minimal for Phase 3 (English only). Phase 11 extends to HI/ML.
 * Callers should always route static strings through `label(key)` so
 * localization is a table swap, not a code rewrite.
 */
const _LABELS = {
  'tab.by_scene':               'By Scene',
  'tab.by_location':            'By Location',
  'tab.by_character':           'By Character',
  'tab.special_requirements':   'Special Requirements',
  'tab.assets':                 'Assets',
  'tab.by_location.desc':       'Base kits per location + scene overrides. Coming in Phase 5.',
  'tab.by_character.desc':      'Signature props + costume/prop crossovers per character. Coming in Phase 8.',
  'tab.special_requirements.desc':'Weapons, animals, minors, licenses & permits. Coming in Phase 9.',
  'tab.assets.desc':            'Full asset library with add/edit/status flow. Coming in Phase 6.',
  'col.action_props':           'Action Props',
  'col.scene_props':            'Scene Props',
  'col.set_dressing':           'Set Dressing',
  'col.picture_vehicle':        'Picture Vehicle',
  'search.placeholder':         'Search scene # or synopsis',
  'common.more_details':        'View Breakdown',
  'common.view_details':        'View details',
  'drawer.synopsis':            'Synopsis',
  'drawer.look_and_feel':       'Look & Feel',
  'drawer.look_empty':          'No palette or mood boards linked to this scene yet.',
  'drawer.special_requirements':'Special Requirements',
  'drawer.special_empty':       'No special requirements linked yet — coming in Phase 9.',
  'add_asset.disabled_tooltip': 'Coming in Phase 6',
  'type.INT':      'INT',
  'type.EXT':      'EXT',
  'type.INT/EXT':  'INT/EXT',
  'type.I/E':      'I/E',
  'tod.DAY':       'DAY',
  'tod.NIGHT':     'NIGHT',
  'tod.DAWN':      'DAWN',
  'tod.DUSK':      'DUSK',
  'tod.CONTINUOUS':'CONTINUOUS',
};

/** Look up a static Art-dept label. Returns the key back if missing (visible hint). */
export function label(key) {
  return _LABELS[key] ?? key;
}
